import ShopifyClient from "services/shopify-client";

const fetchProducts = async (pageSize) => {
  const products = await ShopifyClient.product.fetchAll(pageSize);
  return products;
};

const fetchByHandle = async (handle) => {
  const product = await ShopifyClient.product.fetchByHandle(handle);
  return product;
};

const fetchUpsellProducts = async (upsell) => {
  if (!upsell) return;

  let skus = [];
  let query = [];

  upsell.forEach(info => {
    let title = info.split(":")[0];
    let sku = info.split(":")[1];

    query.push(`(title:${title})`);
    skus.push(sku);
  });

  const productsQuery = ShopifyClient.graphQLClient.query((shop) => {
    shop.addConnection("products", { 
      args : { 
        first: 50, query: query.join(" OR ")
      } 
    }, (product) => {
      product.add("id");
      product.add("title");
      product.addConnection("variants", { args: {  first: 50 }  }, (variant) => {
        variant.add("title");
        variant.add("sku");
        variant.add("id");
        variant.add("priceV2", price => {
          price.add("amount");
          price.add("currencyCode");
        });
        variant.add("compareAtPriceV2", price => {
          price.add("amount");
          price.add("currencyCode");
        });
        variant.add("image", opts => {
          opts.add("src");
        });

      });
    });
  });

  return await ShopifyClient.graphQLClient.send(productsQuery).then(( { data } ) => {
    let { products } = data;
    let variants = [];

    products?.edges.forEach(product => {
      product.node?.variants?.edges.forEach((e) =>  variants.push(e.node));
    });

    let filtered = variants.filter(variant => skus.includes(variant.sku));
    return filtered;
  });

};

export {
  fetchProducts,
  fetchByHandle,
  fetchUpsellProducts,
};
